module.exports = __webpack_public_path__ + "img/Theme_mariage.e870800.jpg";